import api from 'api';

export const loadConcepts = api(
  'GET /api/gallery-concept-families/fields/concepts'
);
export const loadThumbnails = api(
  'POST /api/gallery-concept-families/fields/thumbnails'
);
